export default __webpack_public_path__ + "static/media/Dia-internacional-das-Mulheres-8M-4.36c0905e.jpg";